import { Helmet } from "react-helmet";
import * as Constants from '../../../Common/Constants'

const HomeMeta = () => {

    return (
        <Helmet>
            <title>Augnito | The Optimal AI Assistant for Healthcare</title>
            <link rel="shortcut icon" href={Constants.SITE_URL + "/favicon.ico"} />
            <link rel="icon" href={Constants.SITE_URL + "/favicon.ico"} />
            <link rel="profile" href="https://gmpg.org/xfn/11" />
            <meta name="description" content="Dictate notes directly into your EMR. Augnito's Voice AI integrates with your EMR, supports 50+ specialties, and adapts to your workflow. Focus more on patients, less on paperwork." />
            <link rel="canonical" href={Constants.SITE_URL} />
            <meta property="og:url" content={Constants.SITE_URL} />
            <meta property="og:title" content="Augnito | The Optimal AI Assistant for Healthcare" />
            <meta property="og:description" content="Dictate notes directly into your EMR. Augnito's Voice AI integrates with your EMR, supports 50+ specialties, and adapts to your workflow. Focus more on patients, less on paperwork." />
            <meta property="og:image" content={Constants.SITE_URL + "/logo192.png"} />
            <meta property="og:type" content="website" />
            <meta property="og:locale" content="en_US" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={Constants.SITE_URL}/>
            <meta name="twitter:site" content="@augnito" />
            <meta name="twitter:title" content="Augnito | The Optimal AI Assistant for Healthcare" />
            <meta name="twitter:description" content="Dictate notes directly into your EMR. Augnito's Voice AI integrates with your EMR, supports 50+ specialties, and adapts to your workflow. Focus more on patients, less on paperwork." />
            <meta name="twitter:creator" content="@augnito" />
            <meta name="twitter:image" content={Constants.SITE_URL + "/logo192.png"} />
            <meta name="copyright" content="Augnito" />
            <meta name="owner" content="Augnito" />
            <link rel="alternate" href={Constants.SITE_URL} hreflang="en-us" />
            <meta name="google-site-verification" content="TivMeqLjfaI6TIRsSF0Kqw0J8UnBPK2PToomuQRwVCs" />
        </Helmet>
    );
};

export default HomeMeta;